
// Decorates the audio frequency to receive the final values for bass or wide.
export const decorateAudioFrequency = (spectrumFrequency, magnitudeTargetMax, exponent, root, baseBarCount, cumulativeMaxMagnitude) => {
    const targetMax = magnitudeTargetMax;

    // Step 1.
    // Normalizes all the values to maximum value.
    // Check the extra high bins and reduce them to get accurate result.

    let magnitudeMultiplier = targetMax / cumulativeMaxMagnitude;
    let normalizedBin = 0;

    for (let i = 0; i < spectrumFrequency.length; i++) { 
        normalizedBin = spectrumFrequency[i] * magnitudeMultiplier;
        spectrumFrequency[i] = normalizedBin <= targetMax ? normalizedBin : targetMax;
    }

    // Step 2.
    // Exaggerate the peaks of a data array with a target max. All values beneath the target max are reduced.
    // The further below the target max a value is, the more it is reduced. Values at or near the target max are barely changed.

    if (exponent > 1) {
        let divisor = Math.pow(targetMax, exponent - 1);
        for (var i = 0; i < spectrumFrequency.length; i++) {
            spectrumFrequency[i] = Math.pow(spectrumFrequency[i], exponent) / divisor;
        }
    }

    // Step 3.
    // Does the opposite of exaggerate.
    // The further below the target max a value is, the more it is increased, approaching the target max.
    // This reduces the exaggeration of peaks in the array. 

    if (root > 1) {
        let exponent = 1 / root;
        let multiplier = Math.pow(Math.pow(targetMax, exponent), root - 1);
    
        for (var i = 0; i < spectrumFrequency.length; i++) {
            spectrumFrequency[i] = Math.pow(spectrumFrequency[i], exponent) * multiplier;
        }
    }

    // Return the final result.
    return conformToBarCount(spectrumFrequency, baseBarCount);
};


export const calculateCumulativeMaxMagnitude = (magnitudes, percentile) => {
    if (!magnitudes)
        return undefined;

    if (magnitudes.length <= 1)
        return magnitudes[0];

    // Sorting the magnitudes from max to min.
    magnitudes.sort((a, b) => b - a);
    
    let maxValuesCount = Math.floor(magnitudes.length * percentile);
    if (maxValuesCount <= 0)
        return magnitudes[0];

    // Take the top X percent of these max values.
    let maxValues = magnitudes.slice(0, maxValuesCount);
    
    // Average them
    let sum = maxValues.reduce((a, b) => a + b, 0);
    let average = sum / maxValues.length;
    return parseFloat(average.toFixed(3));
}


const conformToBarCount = (array, target) => {
    var newArr = [];
    var multiplier = (array.length - 1) / (target - 1);
    
    for (var i = 0; i < target - 1; i++) {
        var point = i * multiplier;
        var part1 = array[Math.floor(point)] * Math.abs(point % 1 - 1);
        var part2 = array[Math.ceil(point)] * (point % 1);
        newArr.push(part1 + part2);
    }

    newArr.push(array[array.length - 1]);
    return newArr;
};